

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import{purchaseReturnDetails} from '../../../@core/interfaces/masters/purchasereturndetails';


export interface PurchaseReturnParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface PurchaseReturn {
  supplierMst: any;
  purchasereturnreason: any;
  

  returnId:string;
  returnDate: string;

  invoiceNo: string;

  invoiceDate: string; 

  supplier: string;

  grnTaxTotal: Number;

  igst: Number;   

  cgst: Number;
  sgstOrUtgst: Number;
  grnDiscType: string;

  grnDiscAmt: Number;
  grnDiscPer: Number;
  grnTotal: Number;
  grnGrandTotal:Number;
  reasonId: Number;
  returnRemarks: string;
  returnStatus: string;

  supplierMobile: string;
  creditNoteValue:Number;
  returnValue:Number;
  roundOffMode: string;
  roundOffAmt:Number;
  comments: string;
  grnNetTotal: Number;

  createdBy: any;
  createdDate: string;
  
  //New Column
  
  updatedBy: any; 
  updatedDate: Date;
  updatedIP: string;  
  createdIP: string;

  grnDiscValue: Number;
  grnDiscFinalTotal: Number;
  purchaseReturnDetDto:purchaseReturnDetails[];
    tenantId?: string;
    branchId?: string;    
  
    parameters?: PurchaseReturnParameter[];
    links?: any;
}
export interface DistinctReason{
  id:string;
  name:string;
}

export abstract class PurchaseReturnData {
  
  abstract list(url: string): Observable<PurchaseReturn[]>;
  abstract create(url: string,data: PurchaseReturn): Observable<any>;
  abstract update(url: string,data: PurchaseReturn): Observable<any>;
  abstract delete(url: string): Observable<any>;
   abstract searchList(url: string,data:any): Observable<any>;
   abstract distinctReason(url:string):Observable<any>;
}
